import { render } from "./SleepTargets.vue?vue&type=template&id=266ad8dc"
import script from "./SleepTargets.vue?vue&type=script&lang=js"
export * from "./SleepTargets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__